export { default } from './Comments.data';
